exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html, body{\n  height: 100%;\n  font-family: Arial, Helvetica, sans-serif\n}\n\na.active {\n  background-color: gray;\n}\n\n#video-background {\n  /*  making the video fullscreen  */\n    position: fixed;\n    right: 0; \n    bottom: 0;\n    min-width: 100%; \n    min-height: 100%;\n    width: auto; \n    height: auto;\n    z-index: -100;\n  }", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/app/app.component.css
// module id = X552
// module chunks = 1